export function falseStub(...args: any[]): false {
    return false;
}
